import { DirectionEnum } from "@/models/enums";

export const tripTypes = [
    {
        label: "Return trip",
        name: "Return trip",
        value: DirectionEnum.Return,
    },
    {
        label: "One way trip",
        name: "One way trip",
        value: DirectionEnum.Outward,
    },
];